import { gql } from '@apollo/client';

export const PROGRAMS = gql`
    query {
        teacherPrograms{
            program_id
            name
            start_date
            end_date
            new_image
            description
            rate
            calendars{                
                program{
                    new_image
                }
                total_booked
            }
            total_booked
        }
    }
`;

export const DETAIL_PROGRAM = gql`
    query ($id: Int!){
        teacherProgramSubscription(program_id:$id){
			calendar_program_id
            start
            classProgram{
                name
                requirement
                description
            }
            zoomTeacher{
                id
                zoom_id
                zoom_link
                zoom_password
                zoom_host_link
            }
            total_booked
		}
		programById(id:$id){
			name
			img
			description
			start_date
			end_date
            new_score
			calendars{
                calendar_program_id
                start
                program{
                    new_image
                }
			}
		}
    }
`;